export const ARYAN_EMAIL_ID = "aryanpatelap411@gmail.com"
export const ARYAN_LINKEDIN_PROFILE = "https://www.linkedin.com/in/aryan-patel-876b13190/"
export const ARYAN_GITHUB_PROFILE = "https://github.com/aryan411"
export const ARYAN_LEETCODE_PROFILE = "https://leetcode.com/u/aryanpatel411/"